import { AppState } from '../root-reducer';

export const selectMyProfile = (state: AppState) => state.accountDomain.myProfile;

export const selectLoggedIn = (state: AppState) => state.accountDomain.loggedIn;

export const selectMyListings = (state: AppState) => state.accountDomain.myListings;

export const selectMyPoints = (state: AppState) => state.accountDomain.myProfile?.points;
